import { createStrictContext } from '@/utils/createStrictContext';

interface RemoveWidgetContextType {
  openRemoveModal: (onOk: () => void) => void;
}

export const { useStrictContext: useRemoveWidgetContext, Provider: RemoveWidgetProvider } =
  createStrictContext<RemoveWidgetContextType>('RemoveWidget');
